import { GenericCollectionFactory } from "../../Common/_generics/GenericCollectionFactory";

export const PMSHostifyStore = GenericCollectionFactory("PMS-HOSTIFY-INTEGRATION");